// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Base text and visuals ===== */
.PEARLIDisplay {
  font-family: 'Inter';
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
}

.contentReport {
  padding: 0 18px;
  display: none;
  background-color: #f1f1f1;
  width: 100%;
  max-height: 24vh;
  font-family: Inter;
  font-size: 1em;
  line-height: 20px;
  white-space: pre-line;
}

/* ===== Fix page scrolling root ===== */
html,
body {
  height: auto !important;
  overflow-y: auto !important;
}

/* ===== MAIN PAGE CONTAINER ===== */
.mainReport {
  min-height: 100vh;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #F8FAFC;
}

/* ===== Outer sections ===== */
.mainpart {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: visible;

  /* === Background image === */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* adjust path as needed */
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  min-height: 100vh; /* ensures it’s visible */
}

.assessments-report {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

/* ===== Printable / core content ===== */
.printView {
  flex: 1 1 auto;
  height: auto;
  min-height: 100vh;
  overflow: visible;
  background-color: transparent; /* make sure background shows through */
}

/* ===== Chart + summary section ===== */
.Report-frame-3 {
  background-color: rgba(248, 250, 252, 0.95);
  display: grid;
  grid-template-columns: minmax(auto, 25%) minmax(10%, auto) auto;
  width: 100%;
  height: auto;
  padding-right: 2%;
}

/* ===== ACTION BUTTONS (BOTTOM SECTION) ===== */
.Report-frame-4 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  width: 100%;
  background: transparent;
  margin-top: 3rem;
  padding-bottom: 3rem;
  flex-wrap: wrap;
}

/* Shared base style */
.Report-frame-4 > button {
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 10px;
  border: none;
  padding: 0.9rem 2.2rem;
  min-width: 220px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

/* Email button (neutral tone) */
.email {
  background: linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%);
  color: #0f172a;
  border: 1px solid #d1d5db;
}

.email:hover {
  background: #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}

/* Retake button (brand teal tone) */
.retake {
  background: linear-gradient(180deg, #0C8F63 0%, #0a7253 100%);
  color: #ffffff;
}

.retake:hover {
  background: linear-gradient(180deg, #0ea372 0%, #0a7a58 100%);
  box-shadow: 0 4px 12px rgba(12, 143, 99, 0.3);
  transform: translateY(-1px);
}

/* Click feedback */
.Report-frame-4 > button:active {
  transform: scale(0.97);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* ===== Star content & summaries ===== */
.starBox {
  background-color: #F1F5F9;
  /* margin: 5%; */
  padding: 5%;
  border-radius: 24px;
  line-height: 20px;
  overflow-y: auto;
  max-height: 60vh;
  white-space: pre-line;
  text-align: left;
  transition: max-height 0.3s ease;
}

.scoreBox{
  max-height: 60vh;
  overflow-y: auto;
}

.starDisplay {
  display: inline;
  vertical-align: top;
  font-family: Inter;
}

/* ===== Collapsible buttons ===== */
.collapsible {
  background-color: white;
  color: black;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  margin-top: 1%;
  border-radius: 5px;
}

.collapsible:hover {
  background-color: #f1f5f9;
}

.score {
  float: right;
  font-weight: 600;
}

/* ===== Caret toggle ===== */
.collapsible .up {
  display: none !important;
}
.collapsible.active .up {
  display: inline-block !important;
}
.collapsible.active .fa-caret-down {
  display: none !important;
}

/* ===== Text / colors ===== */
.textAverageScore {
  font-family: Inter;
  font-weight: bolder;
}

.c1, .c2 { color: #EF4444; }
.c3 { color: #EAB308; }
.c4, .c5 { color: #19B880; }

.report-dashboard {
  max-height: none !important;
  overflow: visible !important;
  display: flex;
  background-color: #F8FAFC;
}

/* ===== Centered description paragraph ===== */
.Report-frame-1 {
  display: flex;
  justify-content: center;
  text-align: justify;
  width: 100%;
  margin-top: 1.5rem;
}

.Report-frame-1 p {
  max-width: 700px;
  line-height: 1.6;
  font-size: 1rem;
  font-family: Inter, sans-serif;
  color: #111827;
}

/* ===== Mobile adjustments ===== */
@media (max-width: 480px) {
  .printView {
    overflow-y: auto;
    overflow-x: hidden;
    max-width: 100vw;
    padding-bottom: 0;
  }

  .Report-frame-4 > button {
    width: 80%;
    font-size: 0.95rem;
    padding: 0.8rem 0;
  }

  .starBox {
    display: flex;
    flex-direction: column;
    max-height: 200vh;
    margin-top: 20%;
  }

  .textAverageScore {
    font-size: 0.8em;
    font-family: Inter;
  }
}

/* Restore bullet points for lists inside report content */
.printView ul,
.contentReport ul,
.starBox ul {
  list-style-type: disc;        /* normal filled circle bullets */
  margin-left: 1.5rem;          /* indent bullets nicely */
  padding-left: 1rem;
}

.printView ol,
.contentReport ol,
.starBox ol {
  list-style-type: decimal;     /* numbered lists */
  margin-left: 1.5rem;
  padding-left: 1rem;
}

/* Optional: improve spacing between list items */
.printView li,
.contentReport li,
.starBox li {
  margin-bottom: 0.4rem;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/Reports/PEARLIReports.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,iBAAiB;;EAEjB,6BAA6B;EAC7B,yDAAuD,EAAE,0BAA0B;EACnF,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;EACtB,iBAAiB,EAAE,yBAAyB;AAC9C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B,EAAE,uCAAuC;AACxE;;AAEA,wCAAwC;AACxC;EACE,2CAA2C;EAC3C,aAAa;EACb,+DAA+D;EAC/D,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA,gCAAgC;AAChC;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,WAAW,cAAc,EAAE;AAC3B,MAAM,cAAc,EAAE;AACtB,WAAW,cAAc,EAAE;;AAE3B;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,0DAA0D;AAC1D;;;EAGE,qBAAqB,SAAS,iCAAiC;EAC/D,mBAAmB,WAAW,0BAA0B;EACxD,kBAAkB;AACpB;;AAEA;;;EAGE,wBAAwB,MAAM,mBAAmB;EACjD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iDAAiD;AACjD;;;EAGE,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":["/* ===== Base text and visuals ===== */\n.PEARLIDisplay {\n  font-family: 'Inter';\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 32px;\n}\n\n.contentReport {\n  padding: 0 18px;\n  display: none;\n  background-color: #f1f1f1;\n  width: 100%;\n  max-height: 24vh;\n  font-family: Inter;\n  font-size: 1em;\n  line-height: 20px;\n  white-space: pre-line;\n}\n\n/* ===== Fix page scrolling root ===== */\nhtml,\nbody {\n  height: auto !important;\n  overflow-y: auto !important;\n}\n\n/* ===== MAIN PAGE CONTAINER ===== */\n.mainReport {\n  min-height: 100vh;\n  height: auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background-color: #F8FAFC;\n}\n\n/* ===== Outer sections ===== */\n.mainpart {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n\n  /* === Background image === */\n  background-image: url('../../../assets/background.svg'); /* adjust path as needed */\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-size: cover;\n  min-height: 100vh; /* ensures it’s visible */\n}\n\n.assessments-report {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n}\n\n/* ===== Printable / core content ===== */\n.printView {\n  flex: 1 1 auto;\n  height: auto;\n  min-height: 100vh;\n  overflow: visible;\n  background-color: transparent; /* make sure background shows through */\n}\n\n/* ===== Chart + summary section ===== */\n.Report-frame-3 {\n  background-color: rgba(248, 250, 252, 0.95);\n  display: grid;\n  grid-template-columns: minmax(auto, 25%) minmax(10%, auto) auto;\n  width: 100%;\n  height: auto;\n  padding-right: 2%;\n}\n\n/* ===== ACTION BUTTONS (BOTTOM SECTION) ===== */\n.Report-frame-4 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1.5rem;\n  width: 100%;\n  background: transparent;\n  margin-top: 3rem;\n  padding-bottom: 3rem;\n  flex-wrap: wrap;\n}\n\n/* Shared base style */\n.Report-frame-4 > button {\n  font-family: 'Inter', sans-serif;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 10px;\n  border: none;\n  padding: 0.9rem 2.2rem;\n  min-width: 220px;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n}\n\n/* Email button (neutral tone) */\n.email {\n  background: linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%);\n  color: #0f172a;\n  border: 1px solid #d1d5db;\n}\n\n.email:hover {\n  background: #e2e8f0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n  transform: translateY(-1px);\n}\n\n/* Retake button (brand teal tone) */\n.retake {\n  background: linear-gradient(180deg, #0C8F63 0%, #0a7253 100%);\n  color: #ffffff;\n}\n\n.retake:hover {\n  background: linear-gradient(180deg, #0ea372 0%, #0a7a58 100%);\n  box-shadow: 0 4px 12px rgba(12, 143, 99, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Click feedback */\n.Report-frame-4 > button:active {\n  transform: scale(0.97);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* ===== Star content & summaries ===== */\n.starBox {\n  background-color: #F1F5F9;\n  /* margin: 5%; */\n  padding: 5%;\n  border-radius: 24px;\n  line-height: 20px;\n  overflow-y: auto;\n  max-height: 60vh;\n  white-space: pre-line;\n  text-align: left;\n  transition: max-height 0.3s ease;\n}\n\n.scoreBox{\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.starDisplay {\n  display: inline;\n  vertical-align: top;\n  font-family: Inter;\n}\n\n/* ===== Collapsible buttons ===== */\n.collapsible {\n  background-color: white;\n  color: black;\n  cursor: pointer;\n  padding: 18px;\n  width: 100%;\n  border: none;\n  text-align: left;\n  outline: none;\n  font-size: 15px;\n  margin-top: 1%;\n  border-radius: 5px;\n}\n\n.collapsible:hover {\n  background-color: #f1f5f9;\n}\n\n.score {\n  float: right;\n  font-weight: 600;\n}\n\n/* ===== Caret toggle ===== */\n.collapsible .up {\n  display: none !important;\n}\n.collapsible.active .up {\n  display: inline-block !important;\n}\n.collapsible.active .fa-caret-down {\n  display: none !important;\n}\n\n/* ===== Text / colors ===== */\n.textAverageScore {\n  font-family: Inter;\n  font-weight: bolder;\n}\n\n.c1, .c2 { color: #EF4444; }\n.c3 { color: #EAB308; }\n.c4, .c5 { color: #19B880; }\n\n.report-dashboard {\n  max-height: none !important;\n  overflow: visible !important;\n  display: flex;\n  background-color: #F8FAFC;\n}\n\n/* ===== Centered description paragraph ===== */\n.Report-frame-1 {\n  display: flex;\n  justify-content: center;\n  text-align: justify;\n  width: 100%;\n  margin-top: 1.5rem;\n}\n\n.Report-frame-1 p {\n  max-width: 700px;\n  line-height: 1.6;\n  font-size: 1rem;\n  font-family: Inter, sans-serif;\n  color: #111827;\n}\n\n/* ===== Mobile adjustments ===== */\n@media (max-width: 480px) {\n  .printView {\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-width: 100vw;\n    padding-bottom: 0;\n  }\n\n  .Report-frame-4 > button {\n    width: 80%;\n    font-size: 0.95rem;\n    padding: 0.8rem 0;\n  }\n\n  .starBox {\n    display: flex;\n    flex-direction: column;\n    max-height: 200vh;\n    margin-top: 20%;\n  }\n\n  .textAverageScore {\n    font-size: 0.8em;\n    font-family: Inter;\n  }\n}\n\n/* Restore bullet points for lists inside report content */\n.printView ul,\n.contentReport ul,\n.starBox ul {\n  list-style-type: disc;        /* normal filled circle bullets */\n  margin-left: 1.5rem;          /* indent bullets nicely */\n  padding-left: 1rem;\n}\n\n.printView ol,\n.contentReport ol,\n.starBox ol {\n  list-style-type: decimal;     /* numbered lists */\n  margin-left: 1.5rem;\n  padding-left: 1rem;\n}\n\n/* Optional: improve spacing between list items */\n.printView li,\n.contentReport li,\n.starBox li {\n  margin-bottom: 0.4rem;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
